(ns dre.components.icons-iconoir
  (:require 
   ["iconoir-react" :refer [IconoirProvider
                            NavArrowLeft
                            NavArrowRight
                            NavArrowUp
                            NavArrowDown]]
   [reagent.core :as r]))

;Define icons here
(def icon-map
  {:nav-arrow-up [:> NavArrowUp]
   :nav-arrow-right [:> NavArrowRight]
   :nav-arrow-left [:> NavArrowLeft] 
   :nav-arrow-down [:> NavArrowDown]})


(defn icoinor-icon
  "Iconoir Icon Pack is used in DRE projects as per UI/UX.
   Paramaeter:opts can have value color, strokeWidth, width, height
   refer here: https://iconoir.com/docs/packages/iconoir-react"
  ([icon-name]
   [icoinor-icon icon-name {}])
  ([icon-name opts]
   (let [opts (cond-> opts
                (not (:color opts)) (merge {:color "#6C7593"}))]
     [:> IconoirProvider
      {:iconProps opts}
      (icon-name icon-map)])))

(defn antd-pagination-icons
  "Render carets for antd table paginations"
  [page type original-element]
  (let [icon-size {:width ".35em" :height ".25em"}]
    (cond
      (= type "prev") (r/as-element [:span (icoinor-icon :nav-arrow-left icon-size)])
      (= type "next") (r/as-element [:span (icoinor-icon :nav-arrow-right icon-size)])
      :else original-element)))





